import React from "react";
import { useSelector } from "react-redux";
import DynamicModal from "../../Common/DynamicModal";
import DisplaySection from "../../MoneyTransfer/DisplaySection";
import Action from "../../Common/Action";
import i18n from "../../../i18n/config";

// types
import type { RootState } from "../../../types/redux";
import type { SendMoneyLimitDisplay } from "../../../types/sendMoney";
import type { DisplaySectionType, DisplaySectionFieldType } from "../../../types/components";

interface SendMoney24hLimitModalProps {
  open: boolean;
  setClose: React.Dispatch<React.SetStateAction<boolean>>;
}

const SendMoney24hLimitModal = ({
  open,
  setClose,
}: SendMoney24hLimitModalProps): React.ReactElement => {
  const limitDisplays = useSelector(
    (state: RootState) => state.sendMoney.limitDisplays
  );

  // each display's fields run 1..n with ids repeating across displays, so
  // re-key across sections before feeding DisplaySection
  const sections: DisplaySectionType[] = limitDisplays.map(
    (display: SendMoneyLimitDisplay, d: number) => ({
      name: display.limitType,
      id: display.limitType,
      label: "",
      fields: display.limitFields.map(
        (field: DisplaySectionFieldType, f: number) => ({
          ...field,
          id: d * 100 + f,
        })
      ),
    })
  );

  return (
    <DynamicModal
      open={open}
      setClose={setClose}
      showCloseIcon={true}
      className="v3 min-w-400"
      header={
        <p className="bold text-primary font-size-lg mb-0">
          {i18n.t("PAGES.SEND_MONEY.TRANSFER_DETAILS.HOW_24H_LIMIT_WORKS")}
        </p>
      }
      body={<DisplaySection variant="bold-value" sections={sections} />}
      footer={
        <Action
          onClick={() => setClose(false)}
          type="button"
          title={i18n.t("COMMON.CLOSE")}
          className="w-full"
        />
      }
    />
  );
};

export default SendMoney24hLimitModal;